import { PayloadAction } from '@reduxjs/toolkit';

export const SET_LAST_SEARCH_URL = 'zola/weddings/v2/SET_LAST_SEARCH_URL';

type SetLastSearchUrAction = PayloadAction<string, typeof SET_LAST_SEARCH_URL>;

export type WeddingSearchActions = SetLastSearchUrAction;
